import { ecrireJson, lireJson } from '@/lib/stockage';
import { z } from 'zod';

const echecsEcartesSchema = z.array(z.string().min(1));

/**
 * The key under which the failed translations a user dismissed or relaunched are
 * remembered: one entry per account, so that two people on the same browser never hide
 * each other's cards.
 */
export const cleEchecsEcartes = (utilisateurId: string) =>
  `rosetta.echecs-ecartes.${utilisateurId}`;

/**
 * The identifiers of the failed translations that no longer show in the history of
 * `utilisateurId`. They live in `localStorage` of this browser: nothing is written in
 * Tahiti, so on another machine the cards come back.
 */
export function lireEchecsEcartes(utilisateurId: string): ReadonlySet<string> {
  const ids = lireJson(window.localStorage, cleEchecsEcartes(utilisateurId), echecsEcartesSchema);
  return new Set(ids ?? []);
}

/** Remembers that the card of the failed translation `id` is gone, dismissed or relaunched. */
export function ecarterEchec(utilisateurId: string, id: string): void {
  const courants = lireEchecsEcartes(utilisateurId);
  if (courants.has(id)) return;
  ecrireJson(window.localStorage, cleEchecsEcartes(utilisateurId), [...courants, id]);
}
